import { useContext } from 'react';

import { CheckGroupContext } from '../CheckGroup';

export default function useCheckable(props) {
	const groupContext = useContext(CheckGroupContext) || {};
	const { isGroup, activeSwitchItems, onGroupChange, ...groupProps } = groupContext;

	// remove undefined keys
	Object.keys(groupProps).forEach(key => groupProps[key] === undefined && delete groupProps[key]);

	const combinedProps = {
		...props,
		...groupProps
	};
	return {
		getProps: propOverrides => ({ ...combinedProps, ...propOverrides }),
		isGroup,
		activeSwitchItems,
		checkGroup: {
			onChange: onGroupChange
		}
	};
}
